import { render, staticRenderFns } from "./EditUserDialog.vue?vue&type=template&id=202664c4&scoped=true&"
import script from "./EditUserDialog.vue?vue&type=script&lang=ts&"
export * from "./EditUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202664c4",
  null
  
)

export default component.exports